(() => {
  const header = document.querySelector('[data-site-header]');
  const headerGroup = header?.closest('.shopify-section-group-header-group');
  if (!header || !headerGroup) return;

  const root = document.documentElement;
  const compactQuery = window.matchMedia('(max-width: 990px)');
  let lastScrollY = Math.max(window.scrollY || 0, 0);
  let highScrollY = lastScrollY;
  let lowScrollY = lastScrollY;
  let direction = lastScrollY > 0 ? 'down' : 'up';
  let isCondensed = lastScrollY > 132;
  let ticking = false;

  const measureExpandedHeader = () => {
    const wasCondensed = header.classList.contains('is-condensed');
    const wasExpanded = header.classList.contains('is-expanded-on-scroll');

    header.classList.remove('is-condensed', 'is-expanded-on-scroll');
    const height = Math.ceil(header.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty('--gearonimo-header-offset', `${height}px`);
    }

    header.classList.toggle('is-condensed', wasCondensed);
    header.classList.toggle('is-expanded-on-scroll', wasExpanded);
  };

  const applyHeaderState = (currentScrollY) => {
    const isPastTop = currentScrollY > 18;
    header.classList.toggle('is-stuck', isPastTop);
    header.classList.toggle('is-condensed', isCondensed);
    header.classList.toggle('is-expanded-on-scroll', isPastTop && !isCondensed);
    header.dataset.scrollDirection = direction;
  };

  const syncHeader = () => {
    const currentScrollY = Math.max(window.scrollY || 0, 0);
    const delta = currentScrollY - lastScrollY;

    if (Math.abs(delta) > 2) {
      direction = delta > 0 ? 'down' : 'up';
    }

    const foldStart = compactQuery.matches ? 112 : 132;
    const foldDistance = compactQuery.matches ? 34 : 42;
    const revealDistance = compactQuery.matches ? 76 : 92;

    if (currentScrollY <= 28) {
      isCondensed = false;
      highScrollY = currentScrollY;
      lowScrollY = currentScrollY;
    } else if (isCondensed) {
      highScrollY = Math.max(highScrollY, currentScrollY);
      if (highScrollY - currentScrollY > revealDistance) {
        isCondensed = false;
        lowScrollY = currentScrollY;
      }
    } else {
      lowScrollY = Math.min(lowScrollY, currentScrollY);
      if (direction === 'down' && currentScrollY > foldStart && currentScrollY - lowScrollY > foldDistance) {
        isCondensed = true;
        highScrollY = currentScrollY;
      }
    }

    applyHeaderState(currentScrollY);
    lastScrollY = currentScrollY;
  };

  const requestHeaderSync = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      syncHeader();
      ticking = false;
    });
  };

  const handleResize = () => {
    measureExpandedHeader();
    requestHeaderSync();
  };

  measureExpandedHeader();
  syncHeader();
  window.addEventListener('scroll', requestHeaderSync, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });
  window.addEventListener('load', handleResize, { once: true });
  window.setTimeout(handleResize, 120);
})();


// Header dropdown search - Codex 2026-09-04
(() => {
  const initHeaderDropdownSearch = () => {
    document.querySelectorAll('.site-header .site-search').forEach((form) => {
      if (form.dataset.headerDropdownSearchReady === 'true') return;
      form.dataset.headerDropdownSearchReady = 'true';

      const input = form.querySelector('input[type="search"][name="q"]');
      const button = form.querySelector('button[type="submit"]');
      if (!input || !button) return;

      if (!input.id) input.id = 'HeaderSearchInput';
      button.setAttribute('aria-controls', input.id);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-haspopup', 'true');
      input.setAttribute('tabindex', '-1');

      const openSearch = () => {
        form.classList.add('is-search-open');
        button.setAttribute('aria-expanded', 'true');
        input.removeAttribute('tabindex');
        window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
      };

      const closeSearch = () => {
        if (input.value.trim()) return;
        form.classList.remove('is-search-open');
        button.setAttribute('aria-expanded', 'false');
        input.setAttribute('tabindex', '-1');
      };

      button.addEventListener('click', (event) => {
        if (!form.classList.contains('is-search-open')) {
          event.preventDefault();
          event.stopPropagation();
          openSearch();
          return;
        }

        if (!input.value.trim()) {
          event.preventDefault();
          event.stopPropagation();
          openSearch();
        }
      }, true);

      form.addEventListener('submit', (event) => {
        if (!input.value.trim()) {
          event.preventDefault();
          openSearch();
        }
      });

      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        input.value = '';
        closeSearch();
        button.focus({ preventScroll: true });
      });

      document.addEventListener('pointerdown', (event) => {
        if (!form.contains(event.target)) closeSearch();
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDropdownSearch, { once: true });
  } else {
    initHeaderDropdownSearch();
  }

  document.addEventListener('shopify:section:load', initHeaderDropdownSearch);
})();


// Header dropdown search focus hardening - Codex 2026-09-04
(() => {
  const initHeaderDropdownSearchFocus = () => {
    document.querySelectorAll('.site-header .site-search').forEach((form) => {
      if (form.dataset.headerDropdownSearchFocusReady === 'true') return;
      form.dataset.headerDropdownSearchFocusReady = 'true';

      const input = form.querySelector('input[type="search"][name="q"]');
      const button = form.querySelector('button[type="submit"]');
      if (!input || !button) return;

      const focusSearchInput = () => {
        if (!form.classList.contains('is-search-open')) return;
        input.removeAttribute('tabindex');
        window.setTimeout(() => input.focus(), 40);
        window.setTimeout(() => input.focus(), 140);
      };

      button.addEventListener('click', focusSearchInput, true);
      button.addEventListener('pointerup', focusSearchInput, true);
      input.addEventListener('transitionend', focusSearchInput);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDropdownSearchFocus, { once: true });
  } else {
    initHeaderDropdownSearchFocus();
  }

  document.addEventListener('shopify:section:load', initHeaderDropdownSearchFocus);
})();
